import { Component, EventEmitter, inject, Output } from '@angular/core';
import { ButtonsModule, CheckboxModule, DialogModule, DialogService, FormFieldModule, IconModule, SnackBarService } from '@mastechnicaegroup/carelinelive-ui';
import { ErrorPanelComponent } from '@lib/errors/error-panel/error-panel.component';
import { ReactiveFormsModule } from '@angular/forms';
import { CommissionerService } from '@lib/commissioner/commissioner.service';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { SendableRequest } from '@mastechnicaegroup/carelinelive-cdk/requests';
import { CommissionerUser, CommissionerUserSingleResponse, createCommissionerUserFormGroup, StoreCommissionerUserRequest } from '@lib/api/models/commissioner-users';

@Component({
    selector: 'app-commissioner-user-position-dialog',
    imports: [
        ButtonsModule,
        DialogModule,
        ErrorPanelComponent,
        FormFieldModule,
        IconModule,
        ReactiveFormsModule,
        CheckboxModule
    ],
    templateUrl: './edit-commissioner-user-position-dialog.component.html',
    standalone: true,
    styleUrl: './edit-commissioner-user-position-dialog.component.scss'
})
export class EditCommissionerUserPositionDialogComponent {
    @Output() editRegionEvent: EventEmitter<CommissionerUser> = new EventEmitter<CommissionerUser>();

    private readonly _commissionerService = inject(CommissionerService);
    private readonly _snackBar = inject(SnackBarService);

    protected readonly commissionerUser = inject<CommissionerUser>(DIALOG_DATA);
    protected readonly commissionerUserDetailsFormGroup = createCommissionerUserFormGroup(this.commissionerUser);
    protected readonly dialogRef = inject<DialogRef>(DialogRef);


    updateCommissionerUserRequest = new SendableRequest<CommissionerUserSingleResponse, StoreCommissionerUserRequest>({
        request: (payload) => this._commissionerService.updateCommissionerUser(this.commissionerUser.commissioner_id, payload!),

        onSend: () => {
            this.commissionerUserDetailsFormGroup.disable();
        },

        onSuccess: () => {
            this.commissionerUserDetailsFormGroup.enable();
            this._snackBar.open({
                colour: 'success',
                icon: 'check',
                title: 'Position updated'
            });
            this.dialogRef.close();
        },

        onError: () => {
            this.commissionerUserDetailsFormGroup.enable();
        }
    });

    update() {
        if (this.updateCommissionerUserRequest.loading()) {
            return;
        }

        const commissionerData: StoreCommissionerUserRequest = {
            id: this.commissionerUser.user.id,
            position: this.commissionerUserDetailsFormGroup.get('position')?.value ?? ''
        };

        this.updateCommissionerUserRequest.send(commissionerData);
    }

    public static show(dialog: DialogService, data: CommissionerUser) {
        return dialog.openDialog<DialogRef, CommissionerUser>(EditCommissionerUserPositionDialogComponent, {
            data
        });
    }
}
